import { Filter } from './LobbyFilters'
import { FilterOption } from '../ui/lobby/menu/filter/FilterComponent'
import { FeatureToggleService } from '../services/FeatureToggleService'
import { RingGameFeature } from '../data/LobbyData'
import { GameObject } from './MenuFilters'

export class FeatureToggleTableFilter extends Filter {
	private readonly userId: number

	constructor(userId: number) {
		super()
		this.userId = userId
	}

	updateFilter(filterOptions: FilterOption<any>[]) {
		super.updateFilter(filterOptions)
	}

	filter(game: GameObject): boolean {
		const aofAllowed = !FeatureToggleService.allInOrFoldFeature.isEnabled()
			? !game.features?.includes(RingGameFeature.AllInOrFold)
			: true
		const bbjAllowed = !FeatureToggleService.bbjFeature.isEnabled(this.userId)
			? !game.features?.includes(RingGameFeature.BadBeatJackpot)
			: true
		return aofAllowed && bbjAllowed
	}
}